import { decodeBank } from '@rendever/puzzle-core/sudoku';
import { PUZZLE_BANK } from './puzzle-bank.js';
export { PUZZLE_BANK } from './puzzle-bank.js';
let cache = null;
/**
 * The bank decoded into playable/printable puzzles. Memoized — decoding 400
 * puzzles is cheap but pointless to repeat, and consumers hold the result.
 */
export function decodedBank() {
    cache ??= decodeBank(PUZZLE_BANK);
    return cache;
}
/** Live counts per tier — generate inventory claims from this, never by hand. */
export function bankCounts() {
    const counts = {
        easy: PUZZLE_BANK.easy.length,
        medium: PUZZLE_BANK.medium.length,
        hard: PUZZLE_BANK.hard.length,
        expert: PUZZLE_BANK.expert.length,
    };
    return {
        ...counts,
        total: counts.easy + counts.medium + counts.hard + counts.expert,
    };
}
//# sourceMappingURL=index.js.map